export default __webpack_public_path__ + "static/media/carpenter.fb110b4e.png";